import * as React from 'react';
export const affcSvg = React.forwardRef(function affcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#3D6CB3',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M6.51 9.51H9.9l-1.02 3.35H5.5L6.51 9.5zm20.13 9.9a4.83 4.83 0 0 1-3.73 2.94c-1.96.07-3.93-1.1-3.45-3.41l.34-1.37c.27-.82-.41-.75-.55 0l-.34 1.37c-1.49 4.91-7.93 4.16-7.32 0l.34-1.37c.27-.68-.47-.68-.54-.07l-.54 1.85c-1.56 4.57-7.8 3.55-7.12-.41l1.42-4.99h3.4l-1.36 4.5c-.34.9.47.9.54.08l.47-1.71c1.5-4.37 7.73-3.82 7.19.4l-.34 1.17c-.4.96.27 1.1.54.07l.41-1.57c1.36-4.5 8.68-4.17 7.05 1.23-.54 1.36.27 1.23.54.2l1.29-4.37h3.39l-1.63 5.46z',
      }),
    ),
  );
});
affcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var affc = {
  category: 'brand',
  colorable: false,
  name: 'affc',
  svg: affcSvg,
};
